<template>
    <li :class="{ panel_active: open }">
        <div class="brand-strengths__button-wrapper">
            <button @click="toggle" class="brand-strengths__button" type="button">
                <slot name="heading"/>
                <div class="brand_strengths_toggle-container">
                    <slot name="toggle_symbol"/>
                </div>
            </button>
            <p class="brand-strengths__item-copy" v-html="spliceContent(content)"/>
            <transition-panel>
                <div v-show="open">
                    <div class="brand-strengths__item-copy" v-html="joinContent(content)"/>
                </div>
            </transition-panel>
            <hr class="brand-strengths__horizontal-rule">
        </div>
    </li>
</template>

<script>
import TransitionPanel from '@/components/TransitionPanel';

export default {
    name: 'BasePanel',
    components: {
        TransitionPanel,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isActive: undefined,
            accordion: undefined,
        };
    },
    computed: {
        open() {
            return this.accordion ? this === this.accordion.activePanel : this.isActive;
        },
    },
    methods: {
        toggle() {
            if (this.accordion) {
                this.accordion.$emit('set-active-panel', this.open ? null : this);
            } else {
                this.isActive = !this.isActive;
            }
        },
        spliceContent(content) {
            const splicedContent = content.split('.')[0];
            return `${splicedContent}.`;
        },
        joinContent(content) {
            const joinedContent = content;
            return joinedContent
                .split('.')
                .slice(1, content.length)
                .join('.');
        },
    },
    created() {
        let parent = this.$parent;

        while (parent) {
            if (parent.$options.name === 'BaseAccordian') {
                parent.$emit('add-panel', this);
                this.accordion = parent;
                this.isActive = null;

                return;
            }

            parent = parent.$parent;
        }

        this.accordion = null;
        this.isActive = this.active;
    },
};
</script>



// WEBPACK FOOTER //
// BasePanel.vue?f591ce48